import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { createStore } from "redux";
import { Provider } from "react-redux";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import reducer from "./store/reducer";

// TODO: document redux usage
const store = createStore(reducer);

ReactDOM.render(
  // TODO: document Provider usage
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
